<template>
  <div class="admin-banners-wrap">
    <div class="mb-7 mt-5 d-flex flex-wrap">
      <h2 class="headline">Print/Digital Ads</h2>
      <v-spacer></v-spacer>
    </div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{'items-per-page-options': [10, 20]}"
        mobile-breakpoint="100"
        class="table-org"
      >
        <template v-slot:item="{item}">
          <tr class="items-body-row">
            <td>
              <span v-if="!no_data.includes(item.issue)">{{ item.issue }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.title)">{{ item.title }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.page)">{{ item.page }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.page_size)">{{ item.page_size }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.image) && !no_data.includes(item.photo)" @click="$root.$emit('openImage', item.image)" class="pointer action-link">{{ item.photo }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.clicks)">{{ item.clicks }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.visits)">{{ item.visits }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.link)" @click="viewLink(item.link)" class="pointer action-link">{{ item.link }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";

export default {
  name: 'DigitalAds',
  data: () => ({
    no_data: [null, "", undefined, "null"],
    headers: [
      { text: "Issue", value: "issue", sortable: false },
      { text: "Title", value: "title", sortable: false },
      { text: "Page", value: "page", sortable: false },
      { text: "Page Size", value: "page_size", sortable: false },
      { text: "Ad Image", value: "image", sortable: false },
      { text: "Clicks", value: "clicks", sortable: false },
      { text: "Views", value: "visits", sortable: false },
      { text: "Link", value: "link", sortable: false },
    ],
    items: [],
    totalItems: 0,
    search: "",
    options: {},
    loading: false,
    draw: 0,
    tableData: {
      draw: 0,
      length: 10,
      search: "",
      page: 0,
      column: 0,
      dir: "asc"
    },
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong...",
    server_errors: {}
  }),
  watch: {
    options: {
      handler() {
        if (this.draw !== this.tableData.draw) {
          this.initialize();
        }
      },
      deep: true
    },
    search: _.debounce(function() {
      this.typing = false;
      if (this.draw !== this.tableData.draw) {
        this.options.page = 1;
        this.initialize();
      }
    }, 1000)
  },
  mounted() {
    this.initialize()
  },
  methods: {
    initialize() {
      this.loading = true;
      const { sortBy, descending, page, itemsPerPage } = this.options;
      this.tableData.column = 0;
      if (
        !this.no_data.includes(sortBy) &&
        this.headers.some(i => i.value === sortBy && i.sortable !== false)
      ) {
        this.tableData.column = this.headers.find(
          i => i.value === sortBy
        ).sort_column;
      }
      this.tableData.dir = descending === true ? "asc" : "desc";

      this.tableData.length = itemsPerPage;
      this.tableData.page = page;
      this.tableData.search = this.search;
      this.tableData.draw++;
      this.draw = this.tableData.draw;

      ApiService.get("/digital_issues", this.tableData)
        .then(response => {
          this.draw++
          this.items = response.data.digital_issues.data
          this.totalItems = response.data.digital_issues.total
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          console.log(error.message);
        });
    },
    viewLink (link) {
      window.open(link, '_blank')
    }
  }
}
</script>
